import React, { useState } from "react";
import "./VideoCollector.css";
import { BlobServiceClient } from '@azure/storage-blob';
import uuid from 'react-uuid';
import { useTranslation } from 'react-i18next';

const VideoCollector = ({ selectedVideosState, changeVideoState, maxVideoCount }) => {
    const [selectedVideos, setSelectedVideos] = useState(selectedVideosState);
    const [isUploading, setIsUploading] = useState(false);
    const sasToken = process.env.REACT_APP_ODIN_BLOB_TOKEN;
    const containerName = `odin-eagle-feedback-video`;
    const storageAccountName = "spagblob";
    const { t } = useTranslation();

    const uploadFileToBlob = async (file, fileName) => {
        if (!file) return [];

        const blobService = new BlobServiceClient(
            `https://${storageAccountName}.blob.core.windows.net/${sasToken}`
        );
        const containerClient = blobService.getContainerClient(containerName);
        await createBlobInContainer(containerClient, file, fileName);
    };

    const createBlobInContainer = async (containerClient, file, fileName) => {
        setIsUploading(true);
        try {
            const blobClient = containerClient.getBlockBlobClient(fileName);
            const options = { blobHTTPHeaders: { blobContentType: file.type } };
            await blobClient.uploadData(file, options);
            const fileURL = 'https://spagblob.blob.core.windows.net/' + containerName + '/' + fileName;

            setSelectedVideos((previousVideos) => {
                const updatedVideos = previousVideos.concat(fileURL);
                changeVideoState(updatedVideos);
                return updatedVideos;
            });

            console.log("File Uploaded Successfully");
        } catch (error) {
            alert(t('Error When Uploading to Blob'));
            console.log("Error uploading file:", error.message);
        }
        setIsUploading(false);
    };

    function uploadVideoArray(files) {
        let selectVideo = [];
        const promises = Array.from(files)
            .filter(file => file.type.match(/video\/*/))
            .map((file) => {
                const url = URL.createObjectURL(file);
                const video = document.createElement('video');
                return new Promise((resolve, reject) => {
                    video.src = url;
                    video.onloadedmetadata = () => {
                        const durationInMinutes = video.duration/60;

                        if (durationInMinutes <= 3) {
                            resolve({ file, video });
                        } else {
                            alert(`Video ${file.name} is longer than 2 minutes and will not be processed.`);
                            reject(new Error(`Video ${file.name} is longer than 2 minutes`));
                        }

                        // Release the object URL after processing
                        URL.revokeObjectURL(url);
                    };
                    video.onerror = reject;
                });
                
            });
        Promise.all(promises)
            .then((results) => {
                results.forEach(({ file }) => {

                    let currentDate = new Date().toJSON().slice(0, 10);
                    const fileName = currentDate + '-' + uuid() + '.' + file.name.split('.').pop();
                    uploadFileToBlob(file, fileName);
                });
            }).catch(error => {
                console.error("Error uploading videos:", error);
            })
            .finally(() => {
                console.log("Video upload process completed.");
            });
    }

    const onSelectFile = (event) => {
        try {
            const selectedFiles = event.target.files;
            const selectedFilesArray = Array.from(selectedFiles);
            // Call the function to handle the file upload
            uploadVideoArray(selectedFilesArray);
            // Reset the file input value to allow re-selection of the same file
            event.target.value = "";
        } catch (error) {
            // Display an alert with the error message
            alert(`An error occurred while selecting files: ${error.message}`);
            console.error("Error in onSelectFile:", error);
        }
    };

    function deleteHandler(video) {
        const updatedVideos = selectedVideos.filter((e) => e !== video);
        setSelectedVideos(updatedVideos);
        changeVideoState(updatedVideos);
    }

    return (
        <section style={{ marginTop: '-5px', textAlign: 'center' }}>
            {isUploading ? (
                <img
                    src="https://spagblob.blob.core.windows.net/odin-image/Loading.gif"
                    alt="loading"
                />
            ) : (
                <label className="imageLabel custom-file-upload">
                        {t('VideoCollector.Button.Upload')}
                    <br />

                    <input
                        id="imageInput"
                        type="file"
                        name="videos"
                        onChange={onSelectFile}
                        accept="video/mp4, video/quicktime, .mp4, .mov"
                        disabled={selectedVideos.length >= maxVideoCount}
                    />

                </label>
            )}
            <br />

            {selectedVideos.length > 0 &&
                (selectedVideos.length > maxVideoCount ? (
                    <p className="error">
                        {t('ImageCollector.Error.Label1', { maxVideoCount: maxVideoCount })}<br />
                        <span>
                            {t('ImageCollector.Error.Label', { count: selectedVideos.length - maxVideoCount })}
                        </span>
                    </p>
                ) : (
                    <br />
                ))}

            <div className="videos">
                {selectedVideos.map((video, index) => {
                    const videoName = video.split('/').pop(); // Extract filename from URL
                    return (
                        <div key={video} className="video">
                            <span>{videoName}</span>
                            <button className="closeBtnVideo" onClick={() => deleteHandler(video)}>&#10006;</button>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default VideoCollector;